export const GRANULARITY_TYPES = [
    { id: 'hour', label: 'Hora', plural: 'Horas' },
    { id: 'day', label: 'Dia', plural: 'Dias' },
    { id: 'week', label: 'Semana', plural: 'Semanas' },
    { id: 'month', label: 'Mês', plural: 'Meses' },
    { id: 'year', label: 'Ano', plural: 'Anos' },
];

export const GRANULARITY_TYPE_MAP = GRANULARITY_TYPES.reduce((acc, g) => {
    acc[g.id] = g;
    return acc;
}, {});

export function formatGranularity({ type, amount }) {
    const g = GRANULARITY_TYPE_MAP[type];
    if (!g) return '—';
    const n = Number(amount) || 1;
    return `${n} ${n > 1 ? g.plural.toLowerCase() : g.label.toLowerCase()}`;
}
